import { render, staticRenderFns } from "./UserChipMultiSelect.vue?vue&type=template&id=0f763b8d"
import script from "./UserChipMultiSelect.vue?vue&type=script&lang=js"
export * from "./UserChipMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports